import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEFk_puXlAB4x8ZoWfsQDXjeFS9kInjq0",
  authDomain: "parqueoamigo.firebaseapp.com",
  projectId: "parqueoamigo",
  storageBucket: "parqueoamigo.firebasestorage.app",
  messagingSenderId: "1073424847250",
  appId: "1:1073424847250:web:4e29220577304edc33314b",
  measurementId: "G-3CL6T1XYC1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Export the app instance as firebaseApp for secondary auth instances
export { auth, db, storage, app as firebaseApp };
